import { NgModule } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import {
  COMMON_JSS_IMPORTS,
  COMMON_JSS_LAZY_IMPORTS,
  CoreModulesCommonClientModule,
  CoreModulesCommonModule,
} from '@innogy/core/modules/common';
import {
  CoreModulesOpenModule,
  OPEN_JSS_IMPORTS,
  OPEN_JSS_LAZY_IMPORTS,
} from '@innogy/core/modules/open';
import { EssentIconModule } from '@core/icons';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { HeaderOpenEssentContainerComponent } from '@core/navigation-container/header-open-essent';
import {
  ClientOnlyDirective,
  provideBrandColors,
} from '@innogy/utils-deprecated';

import { EssentAppComponent } from './app.component';
import {
  DEPLOY_PATH_PROVIDER,
  VERTICAL_SCROLL_OFFSET_DESKTOP_PROVIDER,
  VERTICAL_SCROLL_OFFSET_MOBILE_PROVIDER,
} from './app.constants';

export const sharedImports = [
  CoreModulesCommonModule.forRoot({
    appName: 'essent',
    basePath: '',
  }),
  CoreModulesOpenModule,
  EssentIconModule,
  JssModule.withComponents(
    [...COMMON_JSS_IMPORTS, ...OPEN_JSS_IMPORTS],
    [...COMMON_JSS_LAZY_IMPORTS, ...OPEN_JSS_LAZY_IMPORTS]
  ),
];

@NgModule({
  imports: [
    CoreModulesCommonClientModule.forRoot(),
    ...sharedImports,
    HeaderOpenEssentContainerComponent,
    ClientOnlyDirective,
  ],
  declarations: [EssentAppComponent],
  providers: [
    DEPLOY_PATH_PROVIDER,
    VERTICAL_SCROLL_OFFSET_DESKTOP_PROVIDER,
    VERTICAL_SCROLL_OFFSET_MOBILE_PROVIDER,
    provideClientHydration(),
    ...provideBrandColors({
      brandColor: '#e60167',
      brandColorDark: '#aa014c',
    }),
  ],
  bootstrap: [EssentAppComponent],
})
export class EssentAppModule {}
